var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoSharedListFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6272 29.2303C15.4506 29.2303 14.7395 28.3847 14.6892 27.2067C14.6892 24.809 17.032 23.982 20.5619 23.9541C24.098 23.9913 26.4471 24.8183 26.4345 27.2067C26.3779 28.3847 25.671 29.2303 24.4965 29.2303H16.6272Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8661 28.5315H30.3668C31.3193 28.5315 31.8926 27.8456 31.9385 26.8903C31.9474 25.2068 30.5095 24.4798 28.25 24.2985",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5434 20.9469C22.2488 20.9469 23.6312 19.5645 23.6312 17.8592C23.6312 16.1538 22.2488 14.7714 20.5434 14.7714C18.8381 14.7714 17.4556 16.1538 17.4556 17.8592C17.4556 19.5645 18.8381 20.9469 20.5434 20.9469Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.236 20.8115C29.3467 20.8115 30.2471 19.911 30.2471 18.8002C30.2471 17.6895 29.3467 16.7891 28.236 16.7891C27.1252 16.7891 26.2247 17.6895 26.2247 18.8002C26.2247 19.911 27.1252 20.8115 28.236 20.8115Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSharedListFound);
export default __webpack_public_path__ + "static/media/no-shared-list-found.41843daa1f8d71bc665111a1ff1efa0f.svg";
export { ForwardRef as ReactComponent };